import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';

import theme from '../theme';
import AdminAppBar from './AdminAppBar';
import CouplesList from './CouplesList';
import CoupleDetail from './Couple';
import EmailTrackingList from './AdminArea/EmailTrackingList';
import SentEmail from './AdminArea/SentEmail';
import InvoiceList from './Invoices/InvoiceList';
import InvoiceDetail from './Invoices/InvoiceDetail';
import PaymentList from './Payments/PaymentList';
import PaymentDetail from './Payments/PaymentDetail';
import UsersList from './AdminArea/UsersList';
import UserDetail from './AdminArea/UserDetail';
import BalanceList from './BalanceList';
import BalanceDetail from './BalanceDetail';
import UserAvailability from './AdminArea/UserAvailability';
import EditUserAvailability from './AdminArea/EditUserAvailability';
import AdminProfile from './AdminProfile';
import LeadsList from './LeadsList';
import LeadChooseOfficiant from './AdminArea/LeadChooseOfficiant';
import LeadsImport from './AdminArea/LeadsImport';
import OfficiantInvoicesList from './Officiants/OfficiantInvoicesList';
import ReferralsReport from './Reports/ReferralsReport';
import RehearsalsReport from './Reports/RehearsalsReport';
import SecondMeetingsReport from './Reports/SecondMeetingsReport';
import RehearsalsMeetingsReport from './Reports/RehearsalsMeetingsReport';
import OfficiantWeddingsReport from './Reports/OfficiantWeddingsReport';
import UpcomingWeddingsReport from './Reports/UpcomingWeddingsReport';
import CancelledWeddingsReport from './Reports/CancelledWeddingsReport';
import PastWeddingsReport from './Reports/PastWeddingsReport';
import InquirySourceReport from './Reports/InquirySourceReport';
import VenuesReport from './Reports/VenuesReport';
import OfficiantsReport from './Reports/OfficiantsReport';
import WeddingShowsReport from './Reports/WeddingShowsReport';
import WeddingShowsByRegionReport from './Reports/WeddingShowsByRegionReport';
import WeddingLocationsReport from './Reports/WeddingLocationsReport';
import PlaceholderCouplesReport from './Reports/PlaceholderCouplesReport';
import PackagesReport from './Reports/PackagesReport';
import WeddingsBookedByDateReport from './Reports/WeddingsBookedByDateReport';
import BookingsByPricePoint from './Reports/BookingsByPricePoint';
import OfficiantWeddingsSearchReport from './Reports/OfficiantWeddingsSearchReport';
import WeddingTeamReport from './Reports/WeddingTeamReport';
import GenericWeddingsReport from './Reports/GenericWeddingsReport';

import CeremonyTemplatesHome from './AdminArea/CeremonyTemplatesHome';
import CeremonyTemplatesList from './AdminArea/CeremonyTemplatesList';
import VenueBalancesReport from './Reports/VenueBalancesReport';
import EventUnavailability from './AdminArea/EventUnavailability';
import EditEventUnavailability from './AdminArea/EditEventUnavailability';
import EventsList from './EventsList';
import WeddingPlanners from './AdminArea/WeddingPlanners';
import EmailTemplates from './AdminArea/EmailTemplates';
import ActivitiesList from './AdminArea/ActivitiesList';
import TextMessagingWrapper from './AdminArea/TextMessagingWrapper';
import TextMessagingStart from './AdminArea/TextMessagingStart';
import TextMessagingStartSingle from './AdminArea/TextMessagingStartSingle';
import TextMessagingConversations from './AdminArea/TextMessagingConversations';

import checkActiveSession from '../checkActiveSession';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 12,
            '&>div': {
                paddingLeft: 0,
                paddingRight: 0
            },
        },
    },
    paper: {
        padding: theme.spacing(3),
    },
}));

const CouplesListWrapper = () => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Couples - Enduring Promises';
    });

    const renderErrorTester = () => {
        const throwError = () => {
            throw new Error('Test error for Bugsnag')
        }
        if (window.location.href.indexOf('?bugsnag') > 0) {
            return (
                <Box mt={2}>
                    <Button onClick={throwError}>Click me</Button>
                </Box>
            )
        }
        return ''
    }

    return (
        <React.Fragment>
            <Paper square className={classes.paper}>
                <CouplesList />
            </Paper>
            <Box mt={2}>
                <Paper square className={classes.paper}>
                    <EventsList />
                </Paper>
            </Box>
            {renderErrorTester()}
        </React.Fragment>
    )
};

const LeadsListWrapper = () => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Leads - Enduring Promises';
    });

    return (
        <Paper square className={classes.paper}>
            <LeadsList />
        </Paper>
    )
}

const ActivitiesListWrapper = () => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Activity Log - Enduring Promises';
    });

    return (
        <Paper square className={classes.paper}>
            <ActivitiesList />
        </Paper>
    )
}

const OtherPagesWrapper = ({ location }) => {
    const classes = useStyles();

    useEffect(() => {
        document.title = `${location.pathname} - Enduring Promises`;
    });

    return (
        <Paper square className={classes.paper}>
            <div>{location.pathname}</div>
        </Paper>
    )
};

const AdminArea = () => {
    const classes = useStyles();

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <AdminAppBar />
                <div className={classes.root}>
                    <Container maxWidth='xl'>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Grid item xs={12}>
                                <Switch>
                                    <Route exact path="/admin" component={CouplesListWrapper} />
                                    <Route exact path="/admin/couples/:id" component={CoupleDetail} />
                                    <Route exact path="/admin/payments/:id" component={PaymentDetail} />
                                    <Route exact path="/admin/payments" component={PaymentList} />
                                    <Route exact path="/admin/invoices/:id" component={InvoiceDetail} />
                                    <Route exact path="/admin/invoices" component={InvoiceList} />
                                    <Route exact path="/admin/emails/:id" component={SentEmail} />
                                    <Route exact path="/admin/emails" component={EmailTrackingList} />
                                    <Route exact path="/admin/users/:id" component={UserDetail} />
                                    <Route exact path="/admin/users" component={UsersList} />
                                    <Route exact path="/admin/balances/:id" component={BalanceDetail} />
                                    <Route exact path="/admin/balances" component={BalanceList} />
                                    <Route exact path="/admin/leads" component={LeadsListWrapper} />
                                    <Route exact path="/admin/leads/officiants/:id" component={LeadChooseOfficiant} />
                                    <Route exact path="/admin/leads/import" component={LeadsImport} />
                                    <Route exact path="/admin/officiants/availability" component={UserAvailability} />
                                    <Route exact path="/admin/officiants/availability/:id" component={EditUserAvailability} />
                                    <Route exact path="/admin/officiants/invoices" component={OfficiantInvoicesList} />
                                    <Route exact path="/admin/officiants/events" component={EventUnavailability} />
                                    <Route exact path="/admin/officiants/events/:id" component={EditEventUnavailability} />
                                    <Route exact path="/admin/reports/referrals" component={ReferralsReport} />
                                    <Route exact path="/admin/reports/rehearsals" component={RehearsalsReport} />
                                    <Route exact path="/admin/reports/second-meetings" component={SecondMeetingsReport} />
                                    <Route exact path="/admin/reports/rehearsals-meetings" component={RehearsalsMeetingsReport} />
                                    <Route exact path="/admin/reports/officiant-weddings" component={OfficiantWeddingsReport} />
                                    <Route exact path="/admin/reports/officiant-weddings-search" component={OfficiantWeddingsSearchReport} />
                                    <Route exact path="/admin/reports/upcoming-weddings" component={UpcomingWeddingsReport} />
                                    <Route exact path="/admin/reports/cancelled-weddings" component={CancelledWeddingsReport} />
                                    <Route exact path="/admin/reports/past-weddings" component={PastWeddingsReport} />
                                    <Route exact path="/admin/reports/inquiry-source" component={InquirySourceReport} />
                                    <Route exact path="/admin/reports/venues" component={VenuesReport} />
                                    <Route exact path="/admin/reports/officiants" component={OfficiantsReport} />
                                    <Route exact path="/admin/reports/booked-complete" component={WeddingLocationsReport} />
                                    <Route exact path="/admin/reports/venue-balances" component={VenueBalancesReport} />
                                    <Route exact path="/admin/reports/wedding-shows-by-region" component={WeddingShowsByRegionReport} />
                                    <Route exact path="/admin/reports/wedding-shows" component={WeddingShowsReport} />
                                    <Route exact path="/admin/reports/placeholder-couples" component={PlaceholderCouplesReport} />
                                    <Route exact path="/admin/reports/packages" component={PackagesReport} />
                                    <Route exact path="/admin/reports/weddings-booked-by-date" component={WeddingsBookedByDateReport} />
                                    <Route exact path="/admin/reports/bookings-by-price-point" component={BookingsByPricePoint} />
                                    <Route exact path="/admin/reports/wedding-team" component={WeddingTeamReport} />
                                    <Route exact path="/admin/reports/weddings" component={GenericWeddingsReport} />
                                    <Route exact path="/admin/profile" component={AdminProfile} />
                                    <Route exact path="/admin/templates" component={CeremonyTemplatesHome} />
                                    <Route exact path="/admin/templates-list" component={CeremonyTemplatesList} />
                                    <Route exact path="/admin/wedding-planners" component={WeddingPlanners} />
                                    <Route exact path="/admin/email-templates" component={EmailTemplates} />
                                    <Route exact path="/admin/activity" component={ActivitiesListWrapper} />
                                    <Route exact path="/admin/sms" component={TextMessagingWrapper} />
                                    <Route exact path="/admin/sms/start" component={TextMessagingStart} />
                                    <Route exact path="/admin/sms/single" component={TextMessagingStartSingle} />
                                    <Route exact path="/admin/sms/conversations" component={TextMessagingConversations} />
                                    <Route path="/" component={OtherPagesWrapper} />
                                </Switch>
                            </Grid>
                        </Grid>
                    </Container>
                </div>
            </Router>
        </ThemeProvider>
    );
}

if (document.getElementById('admin-root')) {
    ReactDOM.render(<AdminArea />, document.getElementById('admin-root'));
    window._token = document.getElementsByName("csrf-token")[0].content;
    checkActiveSession();
}
